export const EMPLOYMENT_TYPE = {
  PAYE: 1,
  SELF_EMPLOYED: 2,
  UNEMPLOYED: 3,
  RETIRED: 4,
  HOME_DUTIES: 6,
  STUDENT: 7,
};
